// extracted by mini-css-extract-plugin
module.exports = {"hidden":"a10a3f92e9--hidden--C5dLb"};